export const deviceModels = {
  homey1s: "homey1s",
  homey1d: "homey1d",
  homey1q: "homey1q",
  homey2s: "homey2s",
  homey2d: "homey2d",
  homey2q: "homey2q",
  homey3s: "homey3s",
  homey3d: "homey3d",
  homey4d: "homey4d",
  homey5q: "homey5q",
  homey6q: "homey6q",
  homey7q: "homey7q",
  HY0016: "HY0016", // Homey Bridge
  HY0038: "HY0038", // Homey Energy Dongle
}